module.exports = __webpack_public_path__ + "img/komashiba.84050a63.jpg";